<template>
	<el-container>
		<Menu :activeIndex='activeIndex'></Menu>
		<el-container>
			<el-header>
				<h2>课程分类管理</h2>
				<el-button size="medium" plain type="success" id='btn_add' @click="dialogBannerVisible = true,clearform()">新增课程分类</el-button>
			</el-header>
			<el-main>
				<!-- 表格 -->
				<el-table :data="tableData" style="width: 100%;" :stripe="true" :border='true' :default-sort="{prop: 'date', order: 'descending'}">
					<el-table-column label="序号" width="100">
						<template slot-scope="scope">
							<div v-text="scope.$index+1"></div>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="课程分类" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="src" label="分类图标">
						<template slot-scope="scope">
							<div class='menupart' :style="{background:scope.row.bgcolor}">
								<img :src="scope.row.imgurl" alt="">
							</div>
						</template>
					</el-table-column>

					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button-group>
								<el-button type="primary" size="mini" plain @click="handleEdit(scope.$index, scope.row),dialogBannerVisible = true">编辑</el-button>
								<el-button size="mini" plain type="danger" @click="handleDelete(tableData, scope.row,scope.$index)">删除</el-button>
							</el-button-group>
						</template>
					</el-table-column>
				</el-table>
			</el-main>
			<el-footer>Copyright &copy; Soren经济学人 技术支持 ：
				<a href="#">苏州西西弗斯商务信息咨询有限公司</a>
			</el-footer>
		</el-container>
		<el-dialog title="课程分类编辑" :visible.sync="dialogBannerVisible">
			<el-form :model="classify_param">
				<el-form-item label="课程分类名称" :label-width="formLabelWidth">
					<el-input v-model="classify_param.name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="背景颜色" :label-width="formLabelWidth">
					<el-color-picker v-model="classify_param.bgcolor" :value='classify_param.bgcolor' style='float:left;margin-right:10px;' show-alpha></el-color-picker>
					<el-input v-model="classify_param.bgcolor" :value='classify_param.bgcolor' style="width:200px;float:left;" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="图标" :label-width="formLabelWidth">
					<el-upload class="avatar-uploader" :action="UploadUrl()" :http-request='submitLogoUpload' :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
						<img v-if="classify_param.imgurl" :src="classify_param.imgurl" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="效果图" :label-width="formLabelWidth">
					<div class='menupart' :style="{background:classify_param.bgcolor}">
						<img :src="classify_param.imgurl" alt="">
					</div>
				</el-form-item>
        <el-form-item label="排序(越大越靠前)" :label-width="formLabelWidth">
          <el-input v-model="classify_param.dictSort" auto-complete="off"></el-input>
        </el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogBannerVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogBannerVisible = false,saveClassify()">确 定</el-button>
			</div>
		</el-dialog>
	</el-container>
</template>
<script>
	export default {
		data() {
			return {
				activeIndex: "9",
				tableData: [],
				formLabelWidth: "150px",
				dialogBannerVisible: false,
				classify_param: {
					mark: 'xueqiu',
					name: "",
					imgurl: "",
					id: "",
          dictSort:0
				}
			};
		},
		created() {
			this.getData();
		},
		updated: function() {
			this.ifHavemark();
		},
		methods: {
			// 页面 表格数据 初始化
			getData() {
				var self = this;
				self.axios.post("/dict/list", {
						mark: localStorage.getItem("mark")
					})
					.then(function(response) {
						if(response.data.code == "600") {
							self.tableData = response.data.data;
						} else if(response.data.code == "400") {
							self.$message({
								type: "error",
								message: "操作失败"
							});
						} else {
							self.ifLogin();
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			UploadUrl: function() {
				//return "https://snow.qdxingao.com/file/uploadLogo";
				return "https://console.sorenenglish.com/api/file/uploadLogo";
			},
			submitLogoUpload(content) {
				console.log(content);
				var self = this;
				//1. 创建formData 利用AXIOS传递
				let formData = new FormData();
				formData.append("file", content.file);
				let config = {
					"Content-Type": "multipart/form-data"
				};
				let var_this = this;
				self.axios.post("/file/uploadLogo", formData, config)
					.then(function(response) {
						//console.log(response);
						self.classify_param.imgurl = response.data.data;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			//form 表单 数据
			saveClassify() {
				var self = this;
				self.axios.post("/dict/add", self.classify_param)
					.then(function(response) {
						console.log(response);
						if(response.data.code == "600") {
							self.$message({
								message: "添加/编辑成功",
								type: "success"
							});
							self.getData();
						} else if(response.data.code == "400") {
							self.$message({
								type: "error",
								message: "操作失败"
							});
						} else {
							self.ifLogin();
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			clearform() {
				var self = this;
				self.classify_param = {
					mark: 'xueqiu',
					name: "",
					imgurl: "",
					id: ""
				}
			},
			handleEdit(index, row) {
				var that = this;
				that.classify_param = {
					mark: 'xueqiu',
					name: row.name,
					imgurl: row.imgurl,
					id: row.id,
					bgcolor: row.bgcolor,
          dictSort : row.dictSort
				}
			},
			handleAvatarSuccess(res, file) {
				console.log(res, file);
				this.classify_param.imgurl = res.data;
			},
			beforeAvatarUpload: function(file) {
				var that = this;
				const isJPG = file.type === 'image/jpeg';
				const isGIF = file.type === 'image/gif';
				const isPNG = file.type === 'image/png';
				const isBMP = file.type === 'image/bmp';
				const isLt2M = file.size / 1024 / 1024 < 2;
				if(!isJPG && !isGIF && !isPNG && !isBMP) {
					that.$message({
						message: '上传图片必须是JPG/GIF/PNG/BMP 格式!',
						type: 'warning'
					});
				}
				if(!isLt2M) {
					that.$message({
						message: '上传图片大小不能超过 2MB!',
						type: 'warning'
					});
				}
				return(isJPG || isBMP || isGIF || isPNG) && isLt2M;
			},
			handleDelete(rows, row, index) {
				//console.log(rows);
				//console.log(this.tableData);
				var self = this;
				self.$confirm("确认删除该课程分类?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					})
					.then(() => {
						self.axios.post("/dict/delete", {
								mark: localStorage.getItem("mark"),
								id: row.id
							})
							.then(function(response) {
								if(response.data.code == "600") {
									self.$message({
										message: "删除成功",
										type: "success"
									});
									self.getData();
								} else if(response.data.code == "400") {
									self.$message({
										type: "error",
										message: "操作失败"
									});
								} else {
									self.ifLogin();
								}

							})
							.catch(function(error) {
								console.log(error);
							});
					})
					.catch(() => {
						self.$message({
							type: "info",
							message: "已取消删除"
						});
					});
			}
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	.el-header {
		position: relative;
	}

	.el-header h2 {
		margin: 0;
		line-height: 60px;
	}

	.el-header #btn_add {
		position: absolute;
		right: 25px;
		top: 12px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #67c23a;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px !important;
		text-align: center;
	}

	.avatar {
		width: 100%;
		height: auto;
		display: block;
	}

	.Saveid {
		cursor: pointer;
		color: #67c23a;
		display: block;
	}

	.menupart {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		position: relative;
	}

	.menupart img {
		display: block;
		max-width: 60%;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
	}

	.edit_bg {
		display: inline-block;
		width: 80px;
	}
</style>



// WEBPACK FOOTER //
// src/components/ClassifyPage.vue